import { Exception } from '../../../../errors/exception'
import { HttpStatusCode } from '../../../../errors/http-status-code'
import type { ChangePasswordRequest } from '../../domain/models/change-password'
import type { IChangePassword } from '../../domain/use-cases/i-change-password'
import type { IChangePasswordClient } from '../data-sources/i-change-password-client'

export class ChangePasswordRepository implements IChangePassword {
  constructor(private readonly dataSource: IChangePasswordClient) {}

  async create(params: ChangePasswordRequest, jwtToken?: string): Promise<boolean> {
    const result = await this.dataSource.create(params, jwtToken)

    if (result.status !== HttpStatusCode.OK) {
      throw new Exception(result.status, result?.message!)
    }

    return result.success
  }
}
